import React from 'react';
export function JaliDivider({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`w-full flex justify-center items-center py-8 opacity-40 ${className}`} aria-hidden="true" data-id="element-109">
      <svg width="120" height="24" viewBox="0 0 120 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-110">
        <path d="M60 2L68 12L60 22L52 12L60 2Z" stroke="currentColor" strokeWidth="1.5" className="text-gold" data-id="element-111" />
        <path d="M30 8L34 12L30 16L26 12L30 8Z" stroke="currentColor" strokeWidth="1" className="text-saffron" data-id="element-112" />
        <path d="M90 8L94 12L90 16L86 12L90 8Z" stroke="currentColor" strokeWidth="1" className="text-saffron" data-id="element-113" />
        <line x1="0" y1="12" x2="20" y2="12" stroke="currentColor" strokeWidth="1" className="text-gold/50" data-id="element-114" />
        <line x1="100" y1="12" x2="120" y2="12" stroke="currentColor" strokeWidth="1" className="text-gold/50" data-id="element-115" />
        <line x1="40" y1="12" x2="46" y2="12" stroke="currentColor" strokeWidth="1" className="text-gold/50" data-id="element-116" />
        <line x1="74" y1="12" x2="80" y2="12" stroke="currentColor" strokeWidth="1" className="text-gold/50" data-id="element-117" />
      </svg>
    </div>;
}